<router-outlet></router-outlet>
<app-designer-tour></app-designer-tour>
<app-ai-support-chat *ngIf="!isAdminPage"></app-ai-support-chat>
